import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Licencas - reutilizavel para 3 tipos:
 *   - type="judge"      -> arbitro    (usa affiliate.judgeLicenses)
 *   - type="instructor" -> instrutor  (usa affiliate.instructorLicenses)
 *   - type="examiner"   -> examinador (usa affiliate.examinerLicenses)
 *
 * Props:
 *  - affiliate: objeto atual
 *  - type: 'judge' | 'instructor' | 'examiner'
 *  - onAdd: callback pra abrir dialog de nova licenca
 *  - onEdit(license): callback pra editar
 *  - onDelete(license): callback pra remover
 */
export function TabLicenses({ affiliate, type, onAdd, onEdit, onDelete }) {
    const { t } = useTranslation();

    // Descobre qual array usar baseado no tipo
    const licensesByType = {
        judge: affiliate.judgeLicenses,
        instructor: affiliate.instructorLicenses,
        examiner: affiliate.examinerLicenses,
    };
    const licenses = licensesByType[type] || [];

    const actionBodyTemplate = (rowData) => (
        <>
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                onClick={() => onEdit(rowData)} />
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
                onClick={() => onDelete(rowData)} />
        </>
    );

    return (
        <>
            <p></p>
            <label htmlFor="name">{affiliate.name}</label>
            <p></p>
            <DataTable value={licenses} responsiveLayout="scroll">
                <Column field="classe" header={t('msg.jkaLicenseClass')} sortable style={{ minWidth: '2rem' }} />
                <Column field="registrationId" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} />
                <Column field="aquisitionDate" header={t('msg.jkaLicenseAquisitionYear')} sortable style={{ minWidth: '1rem' }} />
                <Column field="validDate" header={t('msg.jkaLicenseValid')} sortable style={{ minWidth: '5rem' }} />
                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>
            <p></p>
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAdd} />
        </>
    );
}
